import { createContentContext } from "./createContentContext";

// Usar factory para crear el contexto de DevOps
// Reemplaza la implementación duplicada con la factory reutilizable
const { Context, Provider } = createContentContext("pages-dev-ops", "DevOps");

export const ContentDevOpsContext = Context;
export const ContentDevOpsProvider = Provider;
